import { FC } from "react";




const CoPayModal: FC<{ showModal: boolean; hideModal: () => void; }> = ({ showModal, hideModal }): JSX.Element => {
  return (
    <div className={`modal fade${showModal ? ' show show-modal' : ''}`} id="CoPayModal" onClick={hideModal}>
      <div className="modal-dialog modal-lg modal-dialog-scrollable" onClick={e => e.stopPropagation()}>
        <div className="modal-content copay-modal">
          <div className="modal-header">
            <h3 className="modal-title color-orange">ZILRETTA Co-Pay Program</h3>
            <button type="button" className="btn-close" onClick={hideModal} data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <h6 className="mb-4 fw-semibold">
              The ZILRETTA Co-Pay Program allows eligible patients to pay as little as $0 up to a maximum benefit
              of $1,000 per calendar year.
            </h6>
            <h5 className="color-primary fw-semibold">Eligibility Guidelines</h5>
            <p className="m-0">
              To be eligible for the ZILRETTA Co-Pay Program a patient must be a) 18 years of age or older b) a
              citizen or permanent resident of the United States c) have an on-label diagnosis from their
              healthcare provider d) have commercial insurance and e) not hold any form of federal or state funded
              insurance.
              For full Terms & Conditions of the ZILRETTA Co-Pay insurance Program <a
                href="https://zilretta.com/copay" target="_blank" rel="noreferrer">click here</a>
            </p>
            <br />
            <h5 className="color-primary fw-semibold">Co-Pay Program Enrollment and Claim Filing Directions</h5>
            <p>
              <b className="color-orange">Enrollment:</b> Enrollment into the ZILRETTA Co-Pay Program is easy-
              FlexForward will automatically
              enroll an eligible patient into the co-pay program once a case is submitted to FlexForward.
              Your practice will receive an Enrollment Approval Letter upon co-pay program enrollment approval.
            </p>
            <p className="m-0">
              <b className="color-orange">Claim Filing: </b> 
              
              Filing a ZILRETTA Co-Pay claim is quick and easy! There are 2 ways your practice can file a claim:
              <ol>
                <li>
                  <b>Directly/electronically through your billing software’s workflow via Electronic Data Interchange-</b>
                  simply send a secondary claim to payer ID PSKW0. For more information on the electronic
                  claims process including how to set up your practice
                  <a href="/pages/instruction/claim" target="_blank" rel="noreferrer"> click here</a>
                  <br />
                  OR
                </li>
                <li>
                  <b>Uploading the EOB/EOP to the FlexForward Portal.</b> Once your practice has received the Explanation of Benefit or Payment (EOB/EOP) from the patient’s insurance company please upload it and the submitted claim (CMS 1500 or UB04) to FlexForward. In the Next Steps column below there will be a “Copay Claim” button for easy upload. Please allow 8-15 business days for reimbursement after submitting co-pay claim to FlexForward.”
                </li>
              </ol>


            </p>
            <br />
            <h5 className="color-primary fw-semibold">Specialty Pharmacy (SP) Dispense</h5>
            <p className="m-0">
              If you have elected to have the Specialty Pharmacy dispense ZILRETTA, the Specialty Pharmacy will process
              the co-pay claim and collect adjusted amount (if applicable) from the patient.
            </p>
            <br />
            <div className="alert alert-warning p-2 px-3 fw-bold text-center">
              Please contact FlexForward on any specific co-pay claim/case questions.
            </div>
          </div>
          <div className="modal-footer justify-content-start">
            <button type="button" onClick={hideModal} className="btn btn-primary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CoPayModal
